<div class="dash-widget fade-in">
  <div class="dw-header">
    <div class="dw-title">
      <div class="dw-title__icon" style="background: var(--teal-bg)">
        <mat-icon style="color: var(--teal-dark)">link</mat-icon>
      </div>
      {{ 'GUI.dashboard.labels.patient links sent' | translate }}
      <app-scope-chip scope="clinic"></app-scope-chip>
    </div>
    <div class="dw-header__right">
      <select
        class="dw-period-select"
        #linksPeriodSelect
        (change)="onLinksPeriodChange(linksPeriodSelect.value)"
      >
        <option value="today" [selected]="linksPeriod() === 'today'">
          {{ 'GUI.dashboard.selects.today' | translate }}
        </option>
        <option value="week" [selected]="linksPeriod() === 'week'">
          {{ 'GUI.dashboard.selects.this week' | translate }}
        </option>
        <option value="month" [selected]="linksPeriod() === 'month'">
          {{ 'GUI.dashboard.selects.this month' | translate }}
        </option>
      </select>
      @if (openRate() !== null) {
      <span
        class="kpi__trend kpi__trend--inline"
        [class.kpi__trend--up]="openRate()! > 0"
        [class.kpi__trend--flat]="openRate() === 0"
        >{{ openRate() }}% {{'GUI.dashboard.labels.open' | translate}}</span
      >
      }
    </div>
  </div>

  @if (loading || loadingLinks()) {
  <div class="links-summary">
    @for (_ of [1,2,3]; track $index) {
    <div class="links-stat">
      <div class="skel" style="width: 48px; height: 32px; margin: 0 auto 6px"></div>
      <div class="skel" style="width: 60px; height: 12px; margin: 0 auto"></div>
    </div>
    }
  </div>
  <div class="links-list">
    @for (_ of [1,2,3,4]; track $index) {
    <div class="skel skel--row"></div>
    }
  </div>
  } @else {
  <div class="links-summary">
    <button
      type="button"
      class="links-stat"
      [class.links-stat--active]="filter() === 'all'"
      (click)="filter.set('all')"
    >
      <div class="links-stat__val">{{ linkSummary().sent }}</div>
      <div class="links-stat__label">{{ 'GUI.dashboard.labels.sent' | translate }}</div>
    </button>
    <button
      type="button"
      class="links-stat"
      [class.links-stat--active]="filter() === 'opened'"
      (click)="setFilter('opened')"
    >
      <div class="links-stat__val links-stat__val--teal">{{ linkSummary().opened }}</div>
      <div class="links-stat__label">{{ 'GUI.dashboard.labels.opened' | translate }}</div>
    </button>
    <button
      type="button"
      class="links-stat"
      [class.links-stat--active]="filter() === 'unopened'"
      (click)="setFilter('unopened')"
    >
      <div class="links-stat__val links-stat__val--muted">{{ linkSummary().unopened }}</div>
      <div class="links-stat__label">{{ 'GUI.dashboard.labels.chips.unopened' | translate }}</div>
    </button>
  </div>

  <div class="links-list">
    @for (l of filteredLinks(); track $index) {
    <div class="links-row">
      <div class="links-row__name">
        {{ l.name }} @if (l.type === 'consent') {
        <span class="links-row__type">{{ 'GUI.dashboard.labels.chips.consent' | translate }}</span>
        }
      </div>
      <span class="links-row__opens" [class]="'links-row__opens--' + l.status"> {{ l.text }} </span>
      <a
        class="links-row__link"
        [href]="l.url"
        target="_blank"
        rel="noopener"
        #linkTip="matTooltip"
        [matTooltip]="copiedUrl() === l.url ? ('GUI.dashboard.labels.copied' | translate) : l.url"
        (contextmenu)="copyLink($event, l.url, linkTip)"
      >
        <mat-icon>open_in_new</mat-icon>
      </a>
    </div>
    } @empty {
    <span class="banner-empty"
      >{{ 'GUI.dashboard.labels.no links sent' | translate }} {{ linksPeriodLabel() }}</span
    >
    }
  </div>
  }
</div>
